module.exports = __webpack_public_path__ + "static/media/logo_original.6cb3bc0d.png";